import CONST_SOCKET from '../const/socket'
import CONST_COMPONENT from '../const/component'
import CONST_LINGUAL_NAME from '../const/lingualName'

export {
  socketToComponent,
}

const socketToComponent = {
  [CONST_SOCKET.AUDIO_INPUT]: { name: CONST_COMPONENT.AUDIO, lingualName: CONST_LINGUAL_NAME.AUDIO },
  [CONST_SOCKET.BUTTON_INPUT]: { name: CONST_COMPONENT.BUTTON, lingualName: CONST_LINGUAL_NAME.BUTTON },
  [CONST_SOCKET.CAROUSEL_INPUT]: { name: CONST_COMPONENT.CAROUSEL, lingualName: CONST_LINGUAL_NAME.CAROUSEL },
  [CONST_SOCKET.CAROUSEL_SINGLE_INPUT]: { name: CONST_COMPONENT.CAROUSEL_ITEM, lingualName: CONST_LINGUAL_NAME.CAROUSEL_ITEM },
  [CONST_SOCKET.CONDITION_INPUT]: { name: CONST_COMPONENT.CONDITION, lingualName: CONST_LINGUAL_NAME.CONDITION },
  [CONST_SOCKET.ECOMMERCE_INPUT]: { name: CONST_COMPONENT.ECOMMERCE, lingualName: CONST_LINGUAL_NAME.ECOMMERCE },
  [CONST_SOCKET.FACEBOOK_MEDIA_INPUT]: { name: CONST_COMPONENT.FACEBOOK_MEDIA, lingualName: CONST_LINGUAL_NAME.FACEBOOK_MEDIA },
  [CONST_SOCKET.FILE_INPUT]: { name: CONST_COMPONENT.FILE, lingualName: CONST_LINGUAL_NAME.FILE },
  [CONST_SOCKET.GENERIC_TEMPLATE_INPUT]: { name: CONST_COMPONENT.GENERIC_TEMPLATE, lingualName: CONST_LINGUAL_NAME.GENERIC_TEMPLATE },
  [CONST_SOCKET.IMAGE_INPUT]: { name: CONST_COMPONENT.IMAGE, lingualName: CONST_LINGUAL_NAME.IMAGE },
  
  [CONST_SOCKET.NEW_POSTBACK_INPUT]: { name: CONST_COMPONENT.POSTBACK_NEW, lingualName: CONST_LINGUAL_NAME.POSTBACK_NEW },
  [CONST_SOCKET.NEW_POSTBACK_INPUT_TRIGGER]: { name: CONST_COMPONENT.POSTBACK_NEW, lingualName: CONST_LINGUAL_NAME.POSTBACK_NEW },
  
  [CONST_SOCKET.OTN_INPUT]: { name: CONST_COMPONENT.OTN, lingualName: CONST_LINGUAL_NAME.OTN },
  [CONST_SOCKET.OTN_SINGLE_INPUT]: { name: CONST_COMPONENT.OTN_SINGLE, lingualName: CONST_LINGUAL_NAME.OTN_SINGLE },
  
  [CONST_SOCKET.QUICK_REPLY_INPUT]: { name: CONST_COMPONENT.QUICK_REPLY, lingualName: CONST_LINGUAL_NAME.QUICK_REPLY },
  
  [CONST_SOCKET.REFERENCE_INPUT]: { name: CONST_COMPONENT.POSTBACK, lingualName: CONST_LINGUAL_NAME.POSTBACK },
  [CONST_SOCKET.REFERENCE_INPUT_ACTION_BUTTON]: { name: CONST_COMPONENT.POSTBACK, lingualName: CONST_LINGUAL_NAME.POSTBACK },
  
  [CONST_SOCKET.SEQUENCE_INPUT]: { name: CONST_COMPONENT.SEQUENCE, lingualName: CONST_LINGUAL_NAME.SEQUENCE },
  [CONST_SOCKET.SEQUENCE_SINGLE_INPUT]: { name: CONST_COMPONENT.SEQUENCE_SINGLE, lingualName: CONST_LINGUAL_NAME.SEQUENCE_SINGLE },
  
  [CONST_SOCKET.TEXT_INPUT]: { name: CONST_COMPONENT.TEXT, lingualName: CONST_LINGUAL_NAME.TEXT },
  [CONST_SOCKET.TRIGGER_INPUT]: { name: CONST_COMPONENT.TRIGGER, lingualName: CONST_LINGUAL_NAME.TRIGGER },
  
  [CONST_SOCKET.USER_INPUT_FLOW_INPUT]: { name: CONST_COMPONENT.USER_INPUT_FLOW, lingualName: CONST_LINGUAL_NAME.USER_INPUT_FLOW },
  [CONST_SOCKET.USER_INPUT_FLOW_SINGLE_INPUT]: { name: CONST_COMPONENT.USER_INPUT_FLOW_SINGLE, lingualName: CONST_LINGUAL_NAME.USER_INPUT_FLOW_SINGLE },
  
  [CONST_SOCKET.VIDEO_INPUT]: { name: CONST_COMPONENT.VIDEO, lingualName: CONST_LINGUAL_NAME.VIDEO },
}